module.exports = __webpack_public_path__ + "static/postgres-008ed73207ee5c7e49f10faef971bf9c.png";